import React, { Component } from 'react'

class MenuCategoryNav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeCategory: ''
        };
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        var categories = this.props.categories || [];
        var active = '';
        for (var i = 0; i < categories.length; i++) {
            var el = document.getElementById(categories[i]);
            if (el) {
                var rect = el.getBoundingClientRect();
                if (rect.top <= 160) {
                    active = categories[i];
                }
            }
        }
        if (active !== this.state.activeCategory) {
            this.setState({ activeCategory: active });
        }
    }

    render() {
        var categories = this.props.categories || [];
        var activeCategory = this.state.activeCategory;

        return (
            <nav className="menu_cat_nav">
                {categories.map(function(cat, index) {
                    return (
                        <a
                            key={index}
                            href={"#" + cat}
                            className={activeCategory === cat ? 'active' : ''}
                        >
                            {cat}
                        </a>
                    );
                })}
            </nav>
        );
    }
}

export default MenuCategoryNav;
